import { FC } from 'react';

type Props = {
	className?: string;
};

const Login_01_Icon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M11.6667 2.57918C11.2858 2.52701 10.8962 2.5 10.5 2.5C6.08173 2.5 2.5 5.85787 2.5 10C2.5 14.1422 6.08173 17.5 10.5 17.5C10.8962 17.5 11.2858 17.473 11.6667 17.4208'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
			<path
				d='M11.2513 12.0837C10.8299 11.6741 9.16797 10.5838 9.16797 10.0003M9.16797 10.0003C9.16797 9.41683 10.8299 8.3266 11.2513 7.91699M9.16797 10.0003H17.5013'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default Login_01_Icon;
